module.exports = __webpack_public_path__ + "img/1-map.97699d86.jpg";